import http from '../http'
import {WORKFLOW_URL} from "@/services/endpoints";

export function getWorkflowList() {
    return http.request({
        url: WORKFLOW_URL,
        method: 'GET'
    })
}
